var $91a70639aaa31d2e$exports = {};
$91a70639aaa31d2e$exports = {
    "loading": `Caricamento...`,
    "loadingMore": `Caricamento altri...`
};


export {$91a70639aaa31d2e$exports as default};
//# sourceMappingURL=it-IT.mjs.map
